var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 424.51 421.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 297.37,
    y1: 394.73,
    x2: 368.31,
    y2: 99.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.28,
    y1: 99.2,
    x2: 368.31,
    y2: 99.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.28,
    y1: 99.2,
    x2: 129.54,
    y2: 392.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 212.12,
    y1: 26.45,
    x2: 22.91,
    y2: 262.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 401.6,
    y1: 265.06,
    x2: 212.12,
    y2: 26.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.91,
    y1: 262.94,
    x2: 297.37,
    y2: 394.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 129.54,
    y1: 392.08,
    x2: 401.6,
    y2: 265.06
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "192.37 37.85 203.41 26.45 192.37 15.05 207.76 18.91 212.12 3.64 216.48 18.91 231.87 15.05 220.83 26.45 231.87 37.85 216.48 34 212.12 49.26 207.76 34 192.37 37.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "348.56 110.6 359.6 99.2 348.56 87.8 363.96 91.66 368.31 76.39 372.67 91.66 388.06 87.8 377.02 99.2 388.06 110.6 372.67 106.74 368.31 122.01 363.96 106.74 348.56 110.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "381.85 276.47 392.89 265.06 381.85 253.66 397.25 257.52 401.6 242.26 405.96 257.52 421.35 253.66 410.31 265.06 421.35 276.47 405.96 272.61 401.6 287.87 397.25 272.61 381.85 276.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "277.62 406.14 288.66 394.73 277.62 383.33 293.01 387.19 297.37 371.93 301.72 387.19 317.12 383.33 306.08 394.73 317.12 406.14 301.72 402.28 297.37 417.54 293.01 402.28 277.62 406.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "109.79 403.48 120.83 392.08 109.79 380.67 125.18 384.53 129.54 369.27 133.9 384.53 149.29 380.67 138.25 392.08 149.29 403.48 133.9 399.62 129.54 414.88 125.18 399.62 109.79 403.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.53 110.6 51.57 99.2 40.53 87.8 55.92 91.66 60.28 76.39 64.64 91.66 80.03 87.8 68.99 99.2 80.03 110.6 64.64 106.74 60.28 122.01 55.92 106.74 40.53 110.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.16 274.34 14.2 262.94 3.16 251.53 18.55 255.39 22.91 240.13 27.26 255.39 42.66 251.53 31.62 262.94 42.66 274.34 27.26 270.48 22.91 285.75 18.55 270.48 3.16 274.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "212.91 198.67 216.78 213.97 231.15 207.45 221.6 220.01 235.65 227.19 219.88 227.55 223.03 243.01 212.91 230.9 202.79 243.01 205.95 227.55 190.18 227.19 204.23 220.01 194.68 207.45 209.05 213.97 212.91 198.67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheStar);
export default __webpack_public_path__ + "static/media/TheStar.05e590f13257a78b8f2f3a4b36c3bde6.svg";
export { ForwardRef as ReactComponent };